import { useEffect, useState } from 'react';

// Formats a whole-second span as H:MM:SS (or M:SS under an hour).
export const formatSeconds = (totalSeconds: number): string => {
  const total = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  const mm = minutes.toString().padStart(hours > 0 ? 2 : 1, '0');
  const ss = seconds.toString().padStart(2, '0');
  return hours > 0 ? `${hours}:${mm}:${ss}` : `${mm}:${ss}`;
};

// Formats an elapsed millisecond span as H:MM:SS (or M:SS under an hour).
export const formatElapsed = (ms: number): string => formatSeconds(ms / 1000);

// Ticks once a second while active so an elapsed label stays current; idle (no
// timer, no re-renders) when inactive or no start time. Returns the formatted
// H:MM:SS string, or null when there is nothing to show. Server-owned
// startedAt (live_state.started_at) keeps every viewer on the same origin and
// survives refresh/reconnect.
export const useElapsed = (startedAt: string | null | undefined, active: boolean): string | null => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!active || !startedAt) return;
    setNow(Date.now());
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [active, startedAt]);

  if (!active || !startedAt) return null;
  const start = Date.parse(startedAt);
  if (Number.isNaN(start)) return null;
  return formatElapsed(now - start);
};
